<template>
  <div id="zcgl">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">{{titlestr}}</div>
        <div class="sz">
          <div v-show="$route.params.nr=='index'" class="am-dropdown am-dropdown-flip" id="doc-dropdown-js">
            <i class="am-icon-cog am-dropdown-toggle "></i>
            <ul class="am-dropdown-content">
              <li>
                <router-link class="first" :to="{name: 'zcgl', params: {nr: 'resetpwd'}}">密码重置</router-link>
              </li>
              <li><a @click="logout()">退出登录</a></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
    <component :is="$route.params.nr" class="wrapper min-height" @update:titlestr="val => titlestr = val"></component>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import login from './page/login'
  import resetpwd from './page/resetpwd'
  import updPassword from './page/updPassword'
  import register from './page/register'
  import index from './page/index'
  import gglist from './page/gglist'
  import router from '@/router'

  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'zcgl',
    data () {
      return {
        titlestr: '资产管理'
      }
    },
    mounted: function () {
      $('#doc-dropdown-js').dropdown()
    },
    components: {
      OffCanvas,
      ICP,
      login,
      resetpwd,
      updPassword,
      register,
      index,
      gglist
    },
    methods: {
      logout: function () {
        ajax.logout()
        router.replace({name: 'zcgl', params: {nr: 'login'}})
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  @import "./icon/iconfont.css"
  #zcgl
    background-color #ebedf1
    height 100vh
    .sz
      position absolute
      height 44px
      line-height 44px
      right 14px
      display inline
      background-color #4f6fc0
      width 30px
      .am-dropdown-content
        border 0
        border-radius 5px
        right -12px
        top 70%
        min-width 84px
        background-color #eeeeee
        text-align center
        li
          width 84px
          font-size 12px
          a
            padding 5px 0 5px 0
          .first
            border-bottom 1px solid #d9d9d9
            margin-left 10px
            margin-right 10px
    .wrapper
      background-color #ebedf1
      .top
        height 100px
        line-height 100px
        text-align center
        .iconfont
          color #5b85c4
          font-size 50px
      .form
        padding 0 $bj 0 $bj
        input
          border-radius 5px
          width 100%
          height 40px
          line-height 40px
          padding-left 12px
          color $font_color1
          font-size $font_size4
          margin-bottom 25px
          border 1px solid #000
        button
          color #fff
          font-size 17px
          height 40px
          width 100%
          border 0
          background-color $color1
          border-radius 5px
          margin-bottom 13px
        p
          font-size $font_size4
          color #a88b6b
          text-align center
          span
            margin-left 0
            text-decoration: underline
        .yzm
          width 48%
          font-size $font_size4
          &.disable
            background-color #bcbcbc
</style>



// WEBPACK FOOTER //
// zcgl.vue?30d2998b